import { useSyncExternalStore } from 'react';

/**
 * QA-only, in-memory connectivity overrides. Deliberately dependency-free
 * (mirrors first-party-transport-signal.ts) so the coordinator can read it with
 * no import-cycle risk, and deliberately unpersisted so an app restart always
 * clears it. Exposed only through Debug Admin surfaces.
 */

let simulateFirstPartyApiOutage = false;
const listeners = new Set<() => void>();

export function isFirstPartyApiOutageSimulated(): boolean {
  return simulateFirstPartyApiOutage;
}

export function setSimulateFirstPartyApiOutage(active: boolean): void {
  if (simulateFirstPartyApiOutage === active) return;
  simulateFirstPartyApiOutage = active;
  listeners.forEach((listener) => listener());
}

export function subscribeSimulatedFirstPartyOutage(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Live view of the simulation flag for the Debug Admin and recovery-page controls. */
export function useSimulatedFirstPartyOutage(): boolean {
  return useSyncExternalStore(subscribeSimulatedFirstPartyOutage, isFirstPartyApiOutageSimulated);
}
